export enum AsyncStatusEnum {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed'
};

export type AsyncStatus = AsyncStatusEnum.IDLE | AsyncStatusEnum.LOADING | AsyncStatusEnum.SUCCEEDED | AsyncStatusEnum.FAILED;

export default AsyncStatus;